const languageObj = {
  'Animate old photos': 'تحريك الصور القديمة',
  'Animate faces in your photos with AI technology, create vivid videos.':
    'قم بتحريك الوجوه في صورك باستخدام تقنية الذكاء الاصطناعي ، وإنشاء مقاطع فيديو حية.',
  'Upload a photo': 'حمل الصورة',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.':
    'ملاحظة: يرجى التأكد من أن الوجه في الصور التي حددتها يواجه العدسة ، وإلا فلن تتمكن من معالجته بنجاح.',
  'Uploaded successfully!': 'تم الرفع بنجاح!',
  'Please select a template below': 'الرجاء تحديد قالب أدناه',
  'Choose a GIF': 'اختر ملف GIF',
  'Use this template': 'استخدم هذا النموذج',
  'Verify successfully! You will':
    'تحقق بنجاح! سوف تتلقى الفيديو مع {{email}} قريبا.',
  'You will': 'سوف تتلقى الفيديو مع {{email}} قريبا.',
  'What you should expect to happen next': 'ما يجب أن تتوقع حدوثه بعد ذلك:',
  'We will process your photo into a dynamic video.':
    'سنعالج صورتك في فيديو ديناميكي.',
  'After processing, we will send the video to your email.':
    'بعد المعالجة ، سنرسل الفيديو إلى بريدك الإلكتروني.',
  'You can check the video in your email.':
    'يمكنك التحقق من الفيديو في بريدك الإلكتروني.',
  'Your video will be delivered via email':
    'بعد المعالجة ، سنرسل الفيديو إلى بريدك الإلكتروني.',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.':
    'يستغرق الأمر من 20 إلى 30 دقيقة لتجميع مقطع فيديو ديناميكي ، يرجى التحلي بالصبر. لحماية خصوصيتك ، سيتم حذف الصور التي تم تحميلها تلقائيًا بعد انتهاء المعالجة.',
  'Your Email': 'بريدك الالكتروني',
  'Last Name': 'الاسم الأول',
  'First Name': 'اسم العائلة',
  'Go back': 'رجع',
  'Invalid email address': 'عنوان البريد الإلكتروني غير صالح',
  'Enter verification code': 'أدخل رمز التحقق',
  'Enter the verification code that we sent to':
    'أدخل رمز التحقق الذي أرسلناه إلى {{email}}.',
  Resend: 'إعادة إرسال',
  'Verification code': 'رمز التحقق',
  'Resend after': '{{num}}إعادة الإرسال بعد s',
  'The verification code is invalid. You can request a new one.':
    'رمز التحقق غير صالح. يمكنك طلب واحدة جديدة.',
  'Synthesize Video': 'تجميع الفيديو',
  Next: 'التالي',
  'Too many attempts, please try again later.':
    'محاولات كثيرة. الرجاء معاودة المحاولة في وقت لاحق.',
  'xx people is waitting in front of you to generate image.':
    ' creators ahead of you, please wait...',
  'Animating...': 'Animating...',
  'You are in line...': 'You are in line...',
  'Failed to generate, click to retry.': 'Failed to generate, click to retry.',
  'The processing will be completed soon, are you sure you want to cancel it?':
    'The processing will be completed soon, are you sure you want to cancel it?',
  freeAccountExceed: 'The image size cannot exceed 2MB in free version.',
  freeAccountHD: 'Upgrade to download HD watermark-free images.',
  UpgradeToDownloadAsGIF: 'Upgrade to download video as GIF.',
  UpgradeToUploadLimits: 'Upgrade to unlimited image uploads.',
  DynamicTitle: 'HitPaw Online Animate Old Photos',
  SizeLimit: 'No Image Size Limits',
  UploadLimit: 'Unlimited Image Uploads',
  DownloadNoWaterMark: 'Download HD Image with No Watermark',
  DownloadGIF: 'Download Video as GIF',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  priceWeek: '$3.99',
  priceMonth: '$1.99',
  priceYear: '$0.99',
  Week: 'Week',
  billMonth: '$7.99 Billed Monthly',
  billYear: '$47.99 Billed Annually',
};

export default languageObj;
